export default __webpack_public_path__ + "static/2002-1bc06efb0b1652fd823b008b8c04654c.gif";